/**
 * Petit utilitaire SEO — injecte title + meta description + Open Graph.
 * Utilisé via useEffect dans chaque page.
 */

function getBaseUrl() {
  // Priorité : var d'env prod > origine navigateur > fallback
  const envUrl =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_CANONICAL_URL;
  if (envUrl) return envUrl.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  return 'https://openmeta.tech';
}

function upsertMeta(name, content, useProperty = false) {
  const attr = useProperty ? 'property' : 'name';
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * @param {{ title: string, description: string, path?: string, image?: string, type?: string }} opts
 */
export function setPageMeta({
  title,
  description,
  path = '/',
  image = '/brand/og-cover.png',
  type = 'website',
}) {
  const fullTitle = title.includes('OpenMeta') ? title : `${title} — OpenMeta`;
  document.title = fullTitle;

  const baseUrl = getBaseUrl();
  const url = `${baseUrl}${path}`;
  const imageUrl = image.startsWith('http') ? image : `${baseUrl}${image}`;

  upsertMeta('description', description);
  upsertLink('canonical', url);

  // Open Graph
  upsertMeta('og:title', fullTitle, true);
  upsertMeta('og:description', description, true);
  upsertMeta('og:type', type, true);
  upsertMeta('og:url', url, true);
  upsertMeta('og:image', imageUrl, true);
  upsertMeta('og:site_name', 'OpenMeta', true);
  upsertMeta('og:locale', 'fr_FR', true);

  // Twitter card
  upsertMeta('twitter:card', 'summary_large_image');
  upsertMeta('twitter:title', fullTitle);
  upsertMeta('twitter:description', description);
  upsertMeta('twitter:image', imageUrl);
}
